var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.334a6.673 6.673 0 0 0-6.667 6.667c0 1.063.257 2.113.744 3.056l-.714 2.554c-.08.29.004.6.214.813a.847.847 0 0 0 .813.213l2.553-.713A6.685 6.685 0 0 0 8 14.667a6.673 6.673 0 0 0 6.667-6.666A6.673 6.673 0 0 0 8 1.334Zm3.453 9.123c-.146.41-.866.807-1.19.837-.323.03-.626.147-2.113-.44-1.793-.707-2.927-2.543-3.013-2.663-.09-.117-.72-.954-.72-1.824 0-.866.456-1.293.616-1.47a.65.65 0 0 1 .47-.22c.12 0 .237 0 .34.004.124.006.264.013.397.306.157.347.5 1.22.543 1.31.044.087.074.19.014.307-.057.117-.087.19-.177.293-.087.104-.183.23-.263.31-.087.087-.18.184-.077.36.103.177.457.754.98 1.22.673.6 1.24.787 1.417.877.176.087.28.073.383-.047.103-.116.44-.513.56-.69.117-.176.233-.146.397-.086.16.056 1.026.483 1.203.573.177.087.293.13.337.203.043.074.043.427-.104.84Z",
    fill: "#fff"
  })));
};

export default SvgWhatsapp;